<script setup lang="ts">
const id = 'kontakt';
const hydrationFinished = ref(false);
// To prevent browser from trying to scroll while hydration is still ongoing.
onNuxtReady(() => {
  hydrationFinished.value = true;
});
</script>

<template>
  <div :id="hydrationFinished ? id : undefined" class="gap-r6 flex flex-col">
    <FooterContentContactLinkContainer />
    <FooterContentContactAddress />
  </div>
</template>
